/**
 * Fill path template with the given params
 *
 * @param pathTemplate - path template containing keys
 * @example
 * '/channels/:channelSlug/editions/:editionSlugs'
 * @param params containing subtition values
 * @example
 * {
 *   "channelSlug": "juree",
 *   "editionSlug": "indonesia2018",
 * }
 * @returns filled paths
 * @example
 * '/channels/juree/editions/indonesia2018'
 */
export var fill = function fill(pathTemplate, params) {
  if (!params) return pathTemplate;
  return pathTemplate.replace(/:([a-zA-Z0-9_-]+)/g, function (_fullmatch, paramName) {
    if (paramName in params) {
      return params[paramName];
    }

    return '_';
  });
};